module.exports = {
  firebase: {
    apiKey: "AIzaSyBFyuUJPG2EcJPu9lB8Foq_UkH4aS5G998",
    authDomain: "midwest-usa-20eac.firebaseapp.com",
    projectId: "midwest-usa-20eac",
    storageBucket: "midwest-usa-20eac.firebasestorage.app",
    messagingSenderId: "19207758007",
    appId: "1:19207758007:web:572d07228e39db20c72d32"
  },
  clientName: 'LaSalle'
}